<template>
  <div class="details">
    <div class="back" @click="$router.go(-1)">
      <span></span>返回
    </div>
    <!-- <div class="ask_content" v-show="issetask">
      <p class="closetagbox" @click="tickie9"></p>
      <setask :msg="msg" v-on:funct="successetask"></setask>
    </div> -->
    <!-- 问题详情 -->
    <div class="questionDetail">
      <p class="detailtitle">
        {{question.qu_title}}
        <span v-show="userid==question.user_id" @click="tickie9">
          <ins></ins>修改
        </span>
      </p>
      <p
        class="slightlyquetion"
        v-show="!isquestiondetail"
        @click="isquestiondetail=!isquestiondetail"
      >
        {{question.content}}
        <span class="hasmore" v-if="question.qu_content">
          显示全部
          <sub></sub>
        </span>
      </p>
      <!-- <p v-if='question.content==""&&question.qu_content!=""' class="hasmore" @click="isquestiondetail=!isquestiondetail">显示全部</p> -->
      <viewer>
        <div class="detailquestion" v-show="isquestiondetail" v-html="question.qu_content"></div>
      </viewer>
      <div class="iwantanswers" v-show='!iswhite' @click="tickie9">
        <span></span>我要回答
      </div>
      <!-- <div class="delete_question" v-show="userid==question.user_id" @click="delete_question">
        <span></span>删除
      </div> -->
    </div>
    <!-- 回答问题 -->
    <!-- <div class="answering" v-show="isanswer">
      <quill-editor
        class="editor"
        ref="myTextEditor"
        v-model="answercontent"
        :options="editorOption"
        @blur="onEditorBlur($event)"
        @focus="onEditorFocus($event)"
        @ready="onEditorReady($event)"
        @change="onEditorChange($event)"
      ></quill-editor>
      <div class="answersubmit" @click="answersubmit">提交回答</div>
    </div> -->
    <!-- 查看全部回答 -->
    <div
      class="lookallanswer"
      @click="lookallanswer"
      v-show="answerslist.length>1&&islookall"
    >查看全部{{total_count}}个回答</div>
    <!-- 回答列表 -->
    <div
      class="answerlist infinite-list"
      ref="scrollList"
      v-infinite-scroll="pushnext"
      infinite-scroll-disabled="isloadall"
      infinite-scroll-distance="10"
      infinite-scroll-immediate-check="false"
      v-show="answerslist.length > 0"
    >
      <div
        v-for="(item,index) in answerslist"
        :class="[item.is_detail?'':'isdetail','answersli']"
        :key="index"
      >
        <p class="answers_username">
          <img :src="imgbg[index]" alt srcset />
          {{item.user_name}}
        </p>
        <viewer><pre class="answers_content" v-html="item.ans_content"></pre></viewer>
        <p class="answers_time">发布于{{item.answer_time}}</p>
        <div class="answers_evaluate">
          <div v-show="!item.is_detail" class="li_lookall" @click="item.is_detail=!item.is_detail">
            查看全文
            <span></span>
          </div>
          <p class="answer_star" v-show="!item.is_star" @click="tostar(item.id,index)">
            <strong class="star_span"></strong>
            <span v-show="item.star_count!=0">{{item.star_count}}个</span>点赞
          </p>
          <p
            v-show="item.is_star"
            @click="cancelstar(item.id,index)"
            style="color:#D55D3A;"
            class="answer_cancelstar"
          >
            <img src="../../assets/community/hand_icon_does.png" alt />
            {{item.star_count}}个点赞
          </p>
          <p
            class="answer_comment"
            v-show="!commentisArr[index]"
            @click="setcomment(index,item.id,1)"
          >
            <strong></strong>
            <span v-show="item.comment_count!=0">{{item.comment_count}}条</span>评论
          </p>
          <p
            class="answer_comment"
            v-show="commentisArr[index]"
            @click="setcomment(index,item.id,2)"
          >
            <strong></strong>收起评论
          </p>
          <div class="closeanswer" v-show="item.is_detail" @click="item.is_detail=!item.is_detail">
            收起回答
            <span></span>
          </div>
        </div>
        <div class="answer_comments" v-show="commentisArr[index]">
          <p
            class="comment_count"
            v-show="commentArr[index].comments.length != 0"
          >{{commentArr[index].total_count}}条评论</p>
          <div v-show="commentArr[index].comments.length != 0">
            <div
              class="comment_li"
              v-for="(citem,cindex) in commentArr[index].comments"
              :key="cindex"
            >
              <p class="comment_username">{{citem.user_name}}</p>
              <pre class="comment_comtent" v-html="citem.content"></pre>
              <p class="comment_time">{{citem.create_time}}</p>
              <p
                class="comment_detele"
                v-if="userid == citem.user_id"
                @click="comment_delete(item.id,citem.comment_id,index)"
              >删除</p>
            </div>
          </div>
          <div v-show="commentArr[index].comments.length == 0" class="notcomment">
            <p class="comment_count">还没有评论</p>
          </div>
          <div class="pagination" v-if="commentArr[index].total_pages>1">
            <el-pagination
              @prev-click="handlePre($event,index,item)"
              @next-click="handleNext($event,index,item)"
              @current-change="changePage($event,index,item)"
              :current-page="commentArr[index].current_page"
              layout="prev, pager, next"
              prev-text="上一页"
              next-text="下一页"
              :page-size="1"
              :total="commentArr[index].total_pages"
            ></el-pagination>
          </div>
          <div class="comment_answer">
            <el-input
              class="comment_input"
              type="textarea"
              autosize
              placeholder="写下你的评论..."
              v-model="item.commentsub"
            ></el-input>
            <button @click="comment_submit(item,index)">发表</button>
          </div>
        </div>
      </div>
    </div>
    <div v-show="answerslist.length==0" class="notanswer">
      <img src="../../assets/community/img_que.png" alt srcset />
      <p>
        没有回答~
        <span>现在去添加第一个吧~</span>
      </p>
    </div>
    <!-- 查看全部回答 -->
    <div
      class="lookallanswer"
      @click="lookallanswer"
      v-show="answerslist.length>1&&islookall"
    >查看全部{{total_count}}个回答</div>
    <!-- <div v-show="isgotop" class="gotop" @click="gotop"></div> -->
    <div class="floatask" >
      <div v-show="isgotop" class="gotop" @click="gotop"></div>
    </div>
    <div class="img_open" v-show="openimg">
      <img :src="openimg_img" class="openimg_img" @click="openimg = !openimg" />
    </div>
  </div>
</template>
<script>
import { constants } from "fs";
import { distance } from "../../util/gettime";
import { addstamp } from "../../util/stamp";
import Setask from "../public/setask.vue";
import http from "axios";
import md5 from "js-md5";
// import lrz from "lrz"; //压缩库，需要通过 npm 安装下
// const toolbarOptions = [
//   ["image"],
//   [{ header: 1 }, { header: 2 }], // custom button values
//   ["bold", "italic"], // toggled buttons
//   [{ align: [] }]
// ];
// const uploadConfig = {
//   name: "img", // 必填参数 文件的参数名
//   accept: "image/png, image/gif, image/jpeg" // 可选 可上传的图片格式
// };
export default {
  data() {
    return {
      userid: null,
      question_id: null,
      isquestiondetail: false,
      answercontent: null,
      question: {},
      answerslist: [],
      isanswer: false,
      total_count: null,
      islookall: true,
      answer_currentpage: 1,
      answer_pagesize: 10,
      answer_total_pages: null,
      isloadall: false,
      commentisArr: [],
      commentArr: [],
      page_number: null,
      bgimg: [
        require("../../assets/community/headimg/User_icon_1.png"),
        require("../../assets/community/headimg/User_icon_2.png"),
        require("../../assets/community/headimg/User_icon_3.png"),
        require("../../assets/community/headimg/User_icon_4.png")
      ],
      imgbg: [],
      msg: [],
      issetask: false,
      notice_id: null,
      isgotop:false,
      openimg: false,
      openimg_img: null,
      iswhite:false
    };
  },
  created() {
    this.userid = parseInt(this.$store.state.user_id);
    this.question_id = this.$route.query.qd;
    this.isanswer = this.$route.query.a == 1 ? true : false;

    var that = this;
    this.loadquestion();
    this.loadanswerlist(1);
    this.iswhite = this.$store.state.iswhitelist;
    // this.handlers = {
    //   image: function image() {
    //     var self = this;
    //     // console.log(11111)
    //     var fileInput = self.container.querySelector(
    //       "input.ql-image[type=file]"
    //     );
    //     if (fileInput === null) {
    //       fileInput = document.createElement("input");
    //       fileInput.setAttribute("type", "file");
    //       // 设置图片参数名
    //       if (uploadConfig.name) {
    //         fileInput.setAttribute("name", uploadConfig.name);
    //       }
    //       // 可设置上传图片的格式
    //       fileInput.setAttribute("accept", uploadConfig.accept);
    //       fileInput.classList.add("ql-image");
    //       // 监听选择文件
    //       fileInput.addEventListener("change", function() {
    //         // var data = success;
    //         let file = fileInput.files[0];
    //         // console.log(file)
    //         var reader = new FileReader();
    //         reader.readAsDataURL(file);
    //         let newfile = ''
    //         reader.onload = function (e) { 
    //           newfile = this.result;
    //           let params = {
    //             img:newfile
    //           }
    //           that.$axios.post('community/upload_img',params)
    //           .then(function(res){
    //             // console.log(res)
    //             var url = res.data.data.img
    //             self.quill.insertEmbed(length, "image", url);
    //             self.quill.setSelection(length + 1);
    //           })
    //           // document.getElementById("data").innerText=this.result.substring(this.result.indexOf(',')+1); 
    //         }
    //       });
    //     }
    //     fileInput.click();
    //   }
    //   }
    // this.editorOption = {
    //   modules: {
    //     toolbar: {
    //       // [ "image"], // 链接、图片、视频
    //       container: toolbarOptions,
    //       handlers: this.handlers
    //     } //工具菜单栏配置
    //   },
    //   placeholder: "写回答......", //提示
    //   readyOnly: false, //是否只读
    //   theme: "snow", //主题 snow/bubble
    //   syntax: true
    // };
  },
  mounted(){
    var that = this;
    var two = document.documentElement.clientHeight * 2;

    window.addEventListener("scroll", function(e) {
      var top = document.documentElement.scrollTop;
      if (top > two) {
        that.isgotop = true;
      } else {
        that.isgotop = false;
      }
    });
  },
  methods: {
    isIE() {
        if(!!window.ActiveXObject || "ActiveXObject" in window){
          return true;
        }else{
          return false;
    　　 }
    },
    IEVersion() {
      var userAgent = navigator.userAgent; //取得浏览器的userAgent字符串
      var isIE =
        userAgent.indexOf("compatible") > -1 && userAgent.indexOf("MSIE") > -1; //判断是否IE<11浏览器
      var isEdge = userAgent.indexOf("Edge") > -1 && !isIE; //判断是否IE的Edge浏览器
      var isIE11 =
        userAgent.indexOf("Trident") > -1 && userAgent.indexOf("rv:11.0") > -1;
      if (isIE) {
        var reIE = new RegExp("MSIE (\\d+\\.\\d+);");
        reIE.test(userAgent);
        var fIEVersion = parseFloat(RegExp["$1"]);
        if (fIEVersion == 7) {
          return 7;
        } else if (fIEVersion == 8) {
          return 8;
        } else if (fIEVersion == 9) {
          return 9;
        } else if (fIEVersion == 10) {
          return 10;
        } else {
          return 6; //IE版本<=7
        }
      } else if (isEdge) {
        return "edge"; //edge
      } else if (isIE11) {
        return 11; //IE11
      } else {
        return -1; //不是ie浏览器
      }
    },
    tickie9() {
      alert('系统升级中')
      // var iev = this.IEVersion();
      // if (
      //   iev == 6 ||
      //   iev == 7 ||
      //   iev == 8 ||
      //   iev == 9 ||
      //   iev == 10 ||
      //   iev == "edge"
      // ) {
      //   this.$message({
      //     message: "当前版本过低，请升级或更换chrome浏览器",
      //     type: "warning"
      //   });
      // }else{
      //   window.location.herf = 'about:bank'
      // }
    },
    gotop() {
      window.scrollTo(100, 0);
    },
    successetask(data) {
      // console.log(data)
      this.issetask = data;
      this.$message({
        message: "问题修改成功！",
        type: "success"
      });
      this.loadquestion();
      $("body").css({ overflow: "auto", "margin-right": "0px" });
    },
    delete_question() {
      var that = this;
      var r = confirm("是否确认删除");
      if (r) {
        let params = {
          user_id: parseInt(this.$store.state.user_id),
          question_id: this.question_id
        };
        var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
        this.$axios.delete("community/question", { params }).then(function(res) {
          if (res.data.status_code == 200) {
            that.$router.go(-1);
          }
        });
      }
    },
    set_question() {
      // console.log(this.question.qu_content)
      // console.log(this.question.content)
      this.issetask = true;
      var params = {
        question_id: this.question_id,
        question_title: this.question.qu_title,
        question_content: this.question.qu_content
      };
      this.msg = params;
    },
    loadlistcomment(index, id) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        page: this.commentArr[index].current_page,
        page_size: this.answer_pagesize,
        id:id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + id + "/comments";
      this.$axios.get(url, { params }).then(function(res) {
        that.commentArr[index].current_page = res.data.data.current_page;
        that.commentArr[index].total_pages = res.data.data.total_pages;
        that.commentArr[index].total_count = res.data.data.total_count;
        that.commentArr[index].comments = res.data.data.comments;
        for (var i = 0; i < that.commentArr[index].comments.length; i++) {
          that.commentArr[index].comments[i].create_time = distance(
            that.commentArr[index].comments[i].create_time
          );
        }
      });
    },
    handlePre(index, item) {
      this.commentArr[index].current_page = val;
      this.loadlistcomment(index, item.id);
      // }
    },
    handleNext(index, item) {
      this.commentArr[index].current_page = val;
      this.loadlistcomment(index, item.id);
    },
    changePage(val, index, item) {
      // console.log(item)
      // console.log(index)
      this.commentArr[index].current_page = val;
      this.loadlistcomment(index, item.id);
      // console.log(this.commentArr[index].current_page)
    },
    comment_submit(item, index) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        content: item.commentsub,
        id:item.id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + item.id + "/comment";
      this.$axios.post(url, params).then(function(res) {
        that.commentArr[index].current_page = 1;
        that.loadlistcomment(index, item.id);
        // console.log(that.answerslist[index].commentsub)
        that.answerslist[index].commentsub = "";
        // console.log(that.answerslist[index].commentsub)
      });
    },
    comment_delete(itemid, comment_id, index) {
      var that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        comment_id: comment_id,
        answer_id:itemid
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + itemid + "/comment";
      this.$axios.delete(url, { params }).then(function(res) {
        that.commentArr[index].current_page = 1;
        that.loadlistcomment(index, itemid);
      });
    },
    setcomment(index, id, num) {
      if (num == 1) {
        this.$set(this.commentisArr, index, true);
        this.loadlistcomment(index, id);
      } else {
        this.$set(this.commentisArr, index, false);
      }
    },
    pushnext() {
      if (this.answer_currentpage != this.answer_total_pages) {
        this.answer_currentpage += 1;
        this.loadanswerlist();
      }
    },
    loadquestion() {
      let that = this;
      var params = {};
      if (this.$route.query.nd) {
        params = {
          notice_id: this.$route.query.nd
        };
      }
      // console.log(params)
      let url = "community/question/" + this.question_id;
      this.$axios.get(url, { params }).then(function(res) {
        // console.log(res);
        // console.log(res.data.data.user_id);
        that.question = res.data.data;
        if (that.question.content != "") {
          if (that.question.content.length > 95) {
            var sub = that.question.content.substring(0, 95);
            that.question.content = sub;
            that.question.content += "...";
          }
        }
      });
    },
    insertImgClick(e) {
      // console.log("insertImgClick......");
    },
    fileInsert(e) {
      // console.log("fileInsert......");
    },
    onEditorBlur(e) {
      // console.log("onEditorBlur......");
    },
    onEditorFocus(e) {
      // console.log("onEditorFocus......");
      this.$refs.myTextEditor.quill.enable(true);
    },
    onEditorReady(e) {
      // console.log("onEditorReady......");
    },
    // 编辑器文本发生变化
    onEditorChange({ editor, html, text }) {
      // console.log("onEditorChange......");
    },
    answersubmit() {
      let that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        content: that.answercontent,
        question_id:that.question_id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + that.question_id + "/answer";
      var init_time = new Date();
      var month =
        init_time.getMonth() + 1 > 10
          ? init_time.getMonth() + 1
          : "0" + (init_time.getMonth() + 1);
      var time =
        init_time.getFullYear() + "-" + month + "-" + init_time.getDate();
      // console.log(time)
      var newlist = {
        user_name: this.$store.state.username,
        ans_content: that.answercontent,
        answer_time: time,
        comment_count: 0,
        id: null,
        is_detail: true,
        is_star: false,
        star_count: 0,
        user_id: this.$store.state.user_id
      };
      this.$axios
        .post(url, params)
        .then(function(res) {
          if (res.data.status_code == 200) {
            newlist.id = res.data.data.answer_id;
            // console.log(newlist)
            that.answerslist.unshift(newlist);
            that.commentisArr.unshift(false);
            that.commentArr.unshift({
              current_page: 1,
              total_pages: 1,
              total_count: 0,
              comments: []
            });
            that.imgbg.unshift(that.bgimg[parseInt(4 * Math.random())]);
            that.total_count += 1;
            that.answercontent = null;
            that.isanswer = false;
            that.$message({
              message: "回答发布成功！",
              type: "success"
            });

            // that.loadanswerlist(1);
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    loadanswerlist(num) {
      let that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        page: this.answer_currentpage,
        page_size: this.answer_pagesize,
        question_id:this.question_id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + this.question_id + "/answers";
      this.$axios
        .get(url, { params })
        .then(function(res) {
          // console.log(res);
          if (res.data.status_code == 200) {
            that.total_count = res.data.data.total_count;
            that.answer_total_pages = parseInt(res.data.data.total_pages);
            that.answer_currentpage = parseInt(res.data.data.current_page);
            var imgarr = [];
            for (var j = 0; j < res.data.data.answers.length; j++) {
              imgarr.push(that.bgimg[parseInt(4 * Math.random())]);
            }
            // that.resetimgurl(res.data.data.answers[0].ans_content)
            if (that.answer_currentpage == 1) {
              that.answerslist = res.data.data.answers;
              that.imgbg = imgarr;
            } else {
              that.answerslist = that.answerslist.concat(res.data.data.answers);
              that.imgbg = that.imgbg.concat(imgarr);
            }
            if (that.answer_currentpage == that.answer_total_pages) {
              that.isloadall = true;
            }
            for (var i = 0; i < that.answerslist.length; i++) {
              that.answerslist[i].answer_time = that.answerslist[
                i
              ].answer_time.split(" ")[0];
              that.commentisArr.push(false);
              that.commentArr.push({
                current_page: 1,
                total_pages: 1,
                total_count: 0,
                comments: []
              });
            }
            if (that.answer_currentpage == 1) {
              if (that.answerslist.length > 0) {
                that.answerslist[0].is_detail = true;
              }
            }
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    tostar(id, index) {
      let that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        answer_id:id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + id + "/star";
      this.$axios
        .post(url, params)
        .then(function(res) {
          if (res.data.status_code == 200) {
            that.answerslist[index].is_star = true;
            that.answerslist[index].star_count += 1;
          }
        })
        .catch(function(err) {
          console.log(err);
        });
    },
    cancelstar(id, index) {
      let that = this;
      let params = {
        user_id: parseInt(this.$store.state.user_id),
        answer_id: id
      };
      var sign = addstamp(params)
        delete params.token
        params['sign'] = sign
      let url = "community/" + id + "/star";
      this.$axios.put(url, params).then(function(res) {
        if (res.data.status_code == 200) {
          that.answerslist[index].is_star = false;
          that.answerslist[index].star_count -= 1;
        }
      });
    },
    lookallanswer() {
      // console.log(this.answerslist);
      for (var i = 0; i < this.answerslist.length; i++) {
        this.answerslist[i].is_detail = true;
      }
      this.islookall = false;
    }
  },
  watch:{
    openimg() {
      if (this.openimg) {
        $("body").css({
          overflow: "hidden"
        });
      } else {
        $('body').removeAttr('style')
      }
    }
  }
};
</script>
<style lang="scss" scoped>
.details {
  width: 900px;
  margin: 0 auto;
  padding-bottom: 90px;
  .floatask{
    width: 70px;
    height: 50px;
    margin-left: 20px;
    position: sticky;
    bottom: 10px;
    margin-left: 960px;
    margin-top: -117px;
    .gotop {
      width: 24px;
      height: 24px;
      margin: 0 auto;
      margin-top: 20px;
      cursor: pointer;
      background: url(../../assets/community/Top_icon_nor.png);
      &:hover {
        background: url(../../assets/community/Top_icon_hover.png);
      }
    }
  }
  .back {
    width: 70px;
    height: 30px;
    color: #d55d3a;
    font-size: 18px;
    margin-top: 20px;
    margin-bottom: 12px;
    cursor: pointer;
    span {
      display: inline-block;
      width: 28px;
      height: 28px;
      background: url(../../assets/community/return_icon_nor.png) center center
        no-repeat;
      vertical-align: middle;
      margin-right: 5px;
    }
  }
  .ask_content {
    width: 100%;
    height: 100%;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 990;
    background: rgba(0, 0, 0, 0.63);
    .closetagbox {
      cursor: pointer;
      // border: 1px solid red;
      width: 30px;
      height: 30px;
      position: absolute;
      top: calc(50% - 190px);
      left: calc(50% + 370px);
      background: url(../../assets/community/close.png) no-repeat center center;
      background-size: 100% 100%;
    }
  }
  .questionDetail {
    width: 100%;
    background: #f5efeb;
    padding-top: 38px;
    padding-bottom: 20px;
    .detailtitle {
      width: 840px;
      margin: 0 auto;
      font-size: 24px;
      font-family: PingFangSC-Semibold;
      font-weight: 600;
      color: rgba#333;
      line-height: 28px;
      span {
        color: #ad896b;
        font-weight: 500;
        font-size: 18px;
        line-height: 35px;
        height: 35px;
        cursor: pointer;
        ins {
          width: 24px;
          height: 28px;
          display: inline-block;
          vertical-align: text-top;
          background: url(../../assets/community/pen_icon_nor@2x.png) no-repeat;
          background-size: cover;
        }
        &:hover ins {
          background: url(../../assets/community/pen_icon_pre@2x.png) no-repeat;
          background-size: cover;
        }
      }
    }
    .slightlyquetion {
      cursor: pointer;
    }
    .slightlyquetion,
    .detailquestion {
      width: 840px;
      margin: 0 auto;
      line-height: 28px;
      margin-top: 22px;
      word-break: break-all;
      word-break: break-all;
    }
    .hasmore {
      color: #d55d3a;
      font-family: PingFangSC-Regular;
      font-weight: 600;
      cursor: pointer;
      sub {
        width: 20px;
        height: 20px;
        display: inline-block;
        background: url(../../assets/community/alldown_icon_nor.png) center
          center no-repeat;
      }
      &:hover {
        color: #e83700;
        sub {
          background: url(../../assets/community/alldown_icon_pre.png) center
            center no-repeat;
        }
      }
    }
    .iwantanswers {
      width: 117px;
      height: 35px;
      line-height: 35px;
      border-radius: 8px;
      border: 1px solid #d55d3a;
      color: #d55d3a;
      font-family: PingFangSC-Regular;
      font-weight: 400;
      text-align: center;
      margin: 23px 0px 0px 30px;
      cursor: pointer;
      span {
        width: 20px;
        height: 20px;
        vertical-align: middle;
        display: inline-block;
        margin-top: -4px;
        background: url(../../assets/community/pen_icon.png) center center
          no-repeat;
      }
    }
    .delete_question {
      color: #ad896b;
      margin: 23px 0px 0px 30px;
      line-height: 24px;
      cursor: pointer;
      display: inline-block;
      span {
        width: 24px;
        height: 24px;
        display: inline-block;
        vertical-align: bottom;
        background: url(../../assets/community/delete_icon_nor.png) no-repeat;
        background-size: cover;
      }
      &:hover span {
        background: url(../../assets/community/delete_icon_pre.png) no-repeat;
        background-size: cover;
      }
    }
  }
  .answering {
    width: 100%;
    height: 475px;
    margin-top: 12px;
    background: #fff;
    position: relative;
    .answersubmit {
      width: 118px;
      height: 42px;
      background: #d55d3a;
      text-align: center;
      line-height: 42px;
      color: #fff;
      border-radius: 8px;
      position: absolute;
      right: 25px;
      bottom: 22px;
      cursor: pointer;
    }
  }
  .lookallanswer {
    width: 100%;
    height: 58px;
    line-height: 58px;
    background: #fff;
    text-align: center;
    margin-top: 15px;
    margin-bottom: 10px;
    color: #d55d3a;
    cursor: pointer;
    font-family: PingFangSC-Semibold;
    font-weight: 600;
  }
  .notanswer {
    width: 900px;
    height: 800px;
    margin: 0 auto;
    background: #fff;
    margin-top: 20px;
    border: 1px solid transparent;
    img {
      display: block;
      margin: 0 auto;
      width: 504px;
      height: 169px;
      margin-top: 280px;
      margin-bottom: 40px;
    }
    p {
      text-align: center;
      color: #666;
      font-size: 18px;
      span {
        color: #d55d3a;
      }
    }
  }
  .answerlist {
    width: 900px;
    margin-top: 10px;
    .answersli {
      width: 100%;
      background: #fff;
      margin-bottom: 10px;
      border: 1px solid transparent;
      padding-bottom: 36px;
      .answers_username {
        display: inline-block;
        text-align: center;
        background: rgba(243, 243, 243, 1);
        border-radius: 36px;
        padding: 5px 9px;
        line-height: 24px;
        font-family: PingFang SC;
        font-weight: 600;
        margin-left: 25px;
        margin-top: 20px;
        img {
          width: 26px;
          height: 26px;
          display: inline-block;
          vertical-align: middle;
          // background: url(../../assets/community/headimg/User_icon_1.png) center center no-repeat;
          margin-right: 8px;
        }
      }
      .answers_content {
        width: 850px;
        min-height: 100px;
        margin: 0 auto;
        font-size: 16px;
        margin-top: 15px;
        margin-bottom: 28px;
        white-space: pre-wrap; /* css3.0 */
        white-space: -moz-pre-wrap; /* Firefox */
        white-space: -pre-wrap; /* Opera 4-6 */
        white-space: -o-pre-wrap; /* Opera 7 */
        word-wrap: break-word; /* Internet Explorer 5.5+ */
      }
      .answers_time {
        width: 850px;
        margin: 0 auto;
        margin-bottom: 30px;
        color: #999;
      }
    }
    .answers_evaluate {
      position: relative;
    }
    .isdetail {
      // max-height: 600px;
      position: relative;
      min-height: 200px;
      // border: 1px solid red;
      overflow: hidden;
      .answers_content {
        max-height: 455px;
        overflow: hidden;
      }
      .answers_time {
        display: none;
      }
    }
  }
}
.li_lookall {
  width: 100%;
  height: 170px;
  color: #d55d3a;
  line-height: 170px;
  text-align: center;
  position: absolute;
  font-family: PingFang SC;
  font-weight: 600;
  // border: 1px solid;
  left: 0;
  z-index: 90;
  top: -170px;
  cursor: pointer;
  // border: 1px solid red;
  background: -webkit-linear-gradient(
    transparent 0%,
    #fff 50%
  ); /* Safari 5.1 - 6.0 */
  background: -o-linear-gradient(
    transparent 0%,
    #fff 50%
  ); /* Opera 11.1 - 12.0 */
  background: -moz-linear-gradient(
    transparent 0%,
    #fff 50%
  ); /* Firefox 3.6 - 15 */
  background: linear-gradient(transparent 0%, #fff 50%); /* 标准的语法 */
  span {
    width: 20px;
    height: 20px;
    display: inline-block;
    margin-bottom: -3px;
    background: url(../../assets/community/down_icon_nor.png);
  }
  &:hover span {
    background: url(../../assets/community/down_icon_pre.png);
  }
}
.answers_evaluate {
  width: 854px;
  height: 24px;
  line-height: 24px;
  color: #ad896b;
  margin: 0 auto;
  margin-bottom: 15px;
  z-index: 90;
  p {
    margin-right: 26px;
    display: inline-block;
    cursor: pointer;
    img {
      vertical-align: middle;
      margin-right: 4px;
    }
    strong {
      width: 24px;
      height: 24px;
      // margin-right: 4px;
      display: inline-block;
      vertical-align: middle;
    }
    &:hover {
      color: #9d7a5c;
    }
  }
  .answer_star {
    .star_span {
      vertical-align: top;
      background: url(../../assets/community/hand_icon_nor.png) center center
        no-repeat;
    }
    &:hover {
      .star_span {
        background: url(../../assets/community/hand_icon_pre.png) center center
          no-repeat;
      }
    }
  }
  .answer_cancelstar {
    img {
      vertical-align: top;
    }
  }
  .answer_comment {
    strong {
      background: url(../../assets/community/com_icon_nor.png) center center
        no-repeat;
    }
    &:hover {
      strong {
        background: url(../../assets/community/com_icon_pre.png) center center
          no-repeat;
      }
    }
  }
  .closeanswer {
    font-size: 16px;
    font-family: PingFangSC-Regular;
    font-weight: 400;
    color: rgba(173, 137, 107, 1);
    line-height: 24px;
    float: right;
    cursor: pointer;
    margin-right: 5px;
    span {
      display: inline-block;
      width: 24px;
      height: 24px;
      vertical-align: top;
      background: url(../../assets/community/Packup_icon_nor.png);
    }
    &:hover {
      color: #9d7a5c;
      span {
        background: url(../../assets/community/Packup_icon_pre.png);
      }
    }
  }
}
.img_open {
  width: 100%;
  height: 100%;
  position: fixed;
  top: 0;
  left: 0;
  z-index: 1000;
  box-sizing: border-box;
  overflow-y: scroll;
  overflow-x: hidden;
  /* border: 1px solid red; */
  background: rgba(26, 26, 26, 0.65);
  border-radius: 6px;
  padding-bottom: 10px;
  .openimg_img {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: block;
    margin: 0 auto;
    cursor: -moz-zoom-out;
    cursor: -webkit-zoom-out;
    cursor: zoom-out;
  }
}
.answer_comments {
  width: 840px;
  background: rgba(255, 255, 255, 1);
  box-shadow: 0px 1px 8px 0px rgba(6, 5, 4, 0.11);
  border: 1px solid transparent;
  margin: 0 auto;
  .comment_count {
    margin-top: 20px;
    margin-left: 20px;
    font-family: PingFang SC;
    font-weight: 600;
  }
  .comment_li {
    width: 798px;
    margin: 0 auto;
    border-bottom: 1px solid #e5e5e5;
    padding-top: 20px;
    padding-bottom: 20px;
    position: relative;
    .comment_username {
      font-family: PingFang SC;
      font-weight: 600;
    }
    .comment_comtent {
      white-space: pre-wrap; /* css3.0 */
      white-space: -moz-pre-wrap; /* Firefox */
      white-space: -pre-wrap; /* Opera 4-6 */
      white-space: -o-pre-wrap; /* Opera 7 */
      word-wrap: break-word;
      width: 712px;
      font-family: PingFang SC;
      font-weight: 400;
      margin-top: 3px;
      line-height: 26px;
    }
    .comment_time {
      font-family: PingFang SC;
      font-weight: 400;
      color: rgba(153, 153, 153, 1);
      position: absolute;
      top: 43px;
      right: 0;
      // border: 1px solid red;
    }
    .comment_detele {
      color: #987659;
      margin-top: 10px;
      font-family: PingFang SC;
      font-weight: 400;
      cursor: pointer;
    }
  }
}
.notcomment {
  width: 100%;
  height: 20px;
}
.comment_answer {
  width: 810px;
  margin: 0 auto;
  position: relative;
  margin-top: 30px;
  margin-bottom: 30px;
  display: flex;
  justify-content: space-around;
  // .comment_input {
  //   width: 700px;
  // }
  button {
    width: 98px;
    height: 44px;
    display: inline-block;
    background: rgba(213, 93, 58, 1);
    border-radius: 8px;
    margin-left: 10px;
    border: none;
    color: #fff;
    font-size: 18px;
    font-family: PingFang SC;
    font-weight: 400;
    cursor: pointer;
    position: absolute;
    bottom: 0px;
    right: 0px;
  }
}
.editor {
  line-height: normal !important;
  height: 360px;
  width: 850px;
  margin: 0 auto;
}
.ql-editor {
  min-height: 300px;
  max-height: 540px !important;
  // border: 1px solid green !important;
}
.ql-snow .ql-tooltip[data-mode="link"]::before {
  content: "请输入链接地址:";
}
.ql-snow .ql-tooltip.ql-editing a.ql-action::after {
  border-right: 0px;
  content: "保存";
  padding-right: 0px;
}

.ql-snow .ql-tooltip[data-mode="video"]::before {
  content: "请输入视频地址:";
}

.ql-snow .ql-picker.ql-size .ql-picker-label::before,
.ql-snow .ql-picker.ql-size .ql-picker-item::before {
  content: "14px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="small"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="small"]::before {
  content: "10px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="large"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="large"]::before {
  content: "18px";
}
.ql-snow .ql-picker.ql-size .ql-picker-label[data-value="huge"]::before,
.ql-snow .ql-picker.ql-size .ql-picker-item[data-value="huge"]::before {
  content: "32px";
}

.ql-snow .ql-picker.ql-header .ql-picker-label::before,
.ql-snow .ql-picker.ql-header .ql-picker-item::before {
  content: "文本";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="1"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="1"]::before {
  content: "标题1";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="2"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="2"]::before {
  content: "标题2";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="3"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="3"]::before {
  content: "标题3";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="4"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="4"]::before {
  content: "标题4";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="5"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="5"]::before {
  content: "标题5";
}
.ql-snow .ql-picker.ql-header .ql-picker-label[data-value="6"]::before,
.ql-snow .ql-picker.ql-header .ql-picker-item[data-value="6"]::before {
  content: "标题6";
}

.ql-snow .ql-picker.ql-font .ql-picker-label::before,
.ql-snow .ql-picker.ql-font .ql-picker-item::before {
  content: "标准字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="serif"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="serif"]::before {
  content: "衬线字体";
}
.ql-snow .ql-picker.ql-font .ql-picker-label[data-value="monospace"]::before,
.ql-snow .ql-picker.ql-font .ql-picker-item[data-value="monospace"]::before {
  content: "等宽字体";
}
</style>
<style>
.answersli .answers_content {
  width: 100%;
  /* border: 1px solid red; */
  line-height: 36px;
}
.answersli .answers_content img,
.detailquestion img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
  cursor: -moz-zoom-in;
  cursor: -webkit-zoom-in;
  cursor: zoom-in;
}

.answer_comments .pagination {
  margin: 10px auto 30px;
  width: 100%;
  text-align: center;
}
.answer_comments .pagination .el-pagination {
  line-height: 10px;
}

/* .answer_comments .el-pagination button:hover, */
.answer_comments .el-pagination button:hover {
  color: #d55d3a;
}

.el-pagination button:disabled:hover {
  /* color: #d55d3a; */
  color: #c0c4cc;
}
.answer_comments .el-icon-arrow-left:before,
.answer_comments .el-icon-arrow-right:before {
  /* content: "上一页"; */
  font-size: 16px;
}
.answer_comments .el-pager li.active,
.el-pager li:hover {
  color: #d55d3a;
}
.answer_comments .answersli .answers_content {
  line-height: 36px;
}
.answer_comments .answersli .answers_content img {
  display: block;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}

.answering .ql-container.ql-snow {
  border: 1px solid rgba(173, 137, 107, 0.49) !important;
  border-radius: 10px !important;
  background: #fff;
}
.answering .ql-toolbar.ql-snow + .ql-container.ql-snow {
  border-top: 1px solid rgba(173, 137, 107, 0.49) !important;
}
.answering .ql-editor {
  line-height: 36px;
  font-size: 16px;
}
.answering .ql-editor img {
  display: block;
  max-width: 100%;
  margin: 0 auto;
  margin-top: 20px;
  margin-bottom: 20px;
}
.comment_input .el-textarea__inner {
  width: 700px;
  padding-top: 10px;
  background: #f3ede9;
  border-radius: 8px;
  border: none;
  font-size: 16px;
  /* text-indent: 22px; */
  color: #333;
  outline: none;
}
.comment_input .el-textarea__inner::placeholder {
  color: #a8978c;
}
</style>


// WEBPACK FOOTER //
// src/components/page/questionDetails.vue